import React from "react";
import DetailsModal from "../../../components/ModalDetailsGeneric/ModalDetailsGeneric";
import { CustomButtonVariant } from "../../../components/CustomButton/CustomButton";
import { ModalIcmsLoaderProps } from "../models/ModalOrdes";
import {
  RefundIcmsStatusIcons,
  RefundIcmsStatusTooltip,
} from "../models/Filters";
import {
  IconType,
  StyledIcon,
} from "../../../components/StyledIcon/StyledIcon";
import { buildTaxReimbursementDetailItems } from "../utils/buildTaxReimbursementDetailItems";

const ModalIcmsLoader: React.FC<ModalIcmsLoaderProps> = ({
  withTab,
  isOpen,
  data,
  isView,
  isApproved = false,
  handleClose,
  onDownloadAttachment,
}) => {
  const buttonsOrderApprovedWithoutCaveat = [
    {
      label: "Fechar",
      variant: CustomButtonVariant.CONTAINED,
      onClick: () => {
        handleClose(false, "close");
      },
    },
  ];

  const buttonNewIcmsRequest = [
    {
      label: "Cancelar",
      variant: CustomButtonVariant.OUTLINED,
      onClick: () => {
        handleClose(false, "close");
      },
    },
    {
      label: "Confirmar Solicitação",
      variant: CustomButtonVariant.CONTAINED,
      onClick: () => {
        handleClose(false, "refund");
      },
    },
  ];

  const buttonSeeIcms = [
    {
      label: "Fechar",
      variant: CustomButtonVariant.OUTLINED,
      onClick: () => {
        handleClose(false, "close");
      },
    },
  ];

  const statusIcon: RefundIcmsStatusIcons | undefined =
    RefundIcmsStatusIcons[data.status as keyof typeof RefundIcmsStatusIcons];

  const statusTooltip =
    RefundIcmsStatusTooltip[
      data.status as keyof typeof RefundIcmsStatusTooltip
    ];

  const statusNode =
    statusIcon != null ? (
      <StyledIcon
        iconType={statusIcon as IconType}
        sx={{ width: 20, height: 20 }}
        tooltip={statusTooltip != null ? { title: statusTooltip } : undefined}
      />
    ) : undefined;

  return (
    <DetailsModal
      open={isOpen}
      onClose={() => handleClose(false, "close")}
      title="Detalhes da solicitação de ressarcimento"
      header={{
        title: data.header?.distributor?.value ?? "",
      }}
      data={buildTaxReimbursementDetailItems(
        data,
        withTab,
        statusNode,
        onDownloadAttachment
      )}
      actions={
        isApproved
          ? buttonsOrderApprovedWithoutCaveat
          : isView
          ? buttonSeeIcms
          : buttonNewIcmsRequest
      }
    />
  );
};

export default ModalIcmsLoader;
